var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { Row } from "react-bootstrap";
import { useState } from "react";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import { addCommas } from "@domains/utils/numberMethods";
var PlanDetails = function () {
    var _a;
    var _b = __read(useState(), 2), renewal = _b[0], setRenewal = _b[1];
    var _c = __read(useState(false), 2), loader = _c[0], setLoader = _c[1];
    var _d = __read(useState(), 2), currentPlan = _d[0], setCurrentPlan = _d[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getRenewal = function (acCode) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoader(true);
                    _a = setRenewal;
                    return [4 /*yield*/, di.clients.getADBRenewalData({
                            acCode: acCode,
                        })];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    di.clients
                        .getADBCurrentPlansData({
                        acCode: acCode,
                    })
                        .then(function (resp) {
                        if (resp !== null && resp !== undefined) {
                            setCurrentPlan(resp);
                            setLoader(false);
                        }
                        else {
                            di.clients
                                .getCurrentPlanData({ acCode: acCode })
                                .then(function (resp) {
                                setCurrentPlan(resp);
                                setLoader(false);
                            })
                                .catch(function (resp) {
                                setCurrentPlan(null);
                                setLoader(resp);
                            });
                        }
                    })
                        .catch(function (resp) {
                        setCurrentPlan(null);
                        setLoader(resp);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)) {
            getRenewal(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode);
        }
    }, [selectedAcount]);
    var PlanDetailsColumn = [
        {
            columnName: "Current Plan",
            key: "CurrentPlan",
        },
        {
            columnName: "Amount",
            key: "Amount",
        },
        {
            columnName: "Tenure",
            key: "Tenure",
        },
        {
            columnName: "Auto Renewal",
            key: "AutoRenewal",
        },
    ];
    var PlanDetailsRows = [
        {
            CurrentPlan: addCommas(currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.CURRENT_PLAN),
            Amount: addCommas(currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.AMOUNT),
            Tenure: currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TENURE,
            AutoRenewal: (_a = renewal === null || renewal === void 0 ? void 0 : renewal.data) === null || _a === void 0 ? void 0 : _a.status,
        },
    ];
    var planSubDetails = [
        {
            columnName: "Segment",
            key: "segment",
        },
        {
            columnName: "Subscription Rate",
            key: "sub",
        },
        {
            columnName: "Min Subscription Rate",
            key: "min_sub",
        },
        {
            columnName: "Post Rates",
            key: "post_rate",
        },
        {
            columnName: "Min Post Rates",
            key: "min_post",
        },
        {
            columnName: "Exp. Rates",
            key: "exp_rate",
        },
        {
            columnName: "Min Exp. Rates",
            key: "min_exp",
        },
    ];
    return (React.createElement(React.Fragment, null,
        currentPlan ? (React.createElement(Row, { className: "mx-0 px-0" },
            React.createElement(GenericTable, { columns: PlanDetailsColumn, data: PlanDetailsRows, loader: loader, parentClassName: "salestableParentClass px-0", tableClassName: "salestableclass" }))) : (React.createElement(Row, { className: "pt-5 d-flex justify-content-center DMSanN_14_400 " }, "No data found...")),
        currentPlan && (React.createElement("div", { className: "generic-table salestableParentClass scrollbar-table padding-30 px-0" },
            React.createElement("table", { className: "salestableclass" },
                React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                    React.createElement("th", null, "Segment"),
                    React.createElement("th", null, "Subscription Rate"),
                    React.createElement("th", null, "Min Subscription Rate"),
                    React.createElement("th", null, "Post Rates"),
                    React.createElement("th", null, "Min Post Rates"),
                    React.createElement("th", null, "Exp. Rates"),
                    React.createElement("th", null, "Min Exp. Rates")),
                React.createElement("tbody", null,
                    React.createElement("tr", { className: "DMSanM_14_500 txt_blackOne1" },
                        React.createElement("td", null, "Del"),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Del_rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Del_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_Del_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_Del_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_Del_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_Del_Rate_Min)),
                    React.createElement("tr", { className: "DMSanM_14_500 txt_blackOne1" },
                        React.createElement("td", null, "Intraday/Future"),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.ID_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.ID_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_ID_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_ID_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_ID_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_ID_Rate_Min)),
                    React.createElement("tr", { className: "DMSanM_14_500 txt_blackOne1" },
                        React.createElement("td", null, "Options"),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Opt_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Opt_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_Opt_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_Opt_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_Opt_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_Opt_Rate_Min)),
                    React.createElement("tr", { className: "DMSanM_14_500 txt_blackOne1" },
                        React.createElement("td", null, "CDS Future"),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.CDSRate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.CDSRate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_CDSRate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_CDSRate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_CDSRate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_CDSRate_Min)),
                    React.createElement("tr", { className: "DMSanM_14_500 txt_blackOne1" },
                        React.createElement("td", null, "Commodity"),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Commodity_rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Commodity_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_Commodity_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.TC_Commodity_Rate_Min),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_Commodity_Rate),
                        React.createElement("td", null, currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.Exp_Commodity_Rate_Min))))))));
};
export default PlanDetails;
